import { Leaf, Recycle, Sprout, TreePine } from "lucide-react";

const ECO_ICONS = [
  { id: "leaf", Icon: Leaf },
  { id: "recycle", Icon: Recycle },
  { id: "sprout", Icon: Sprout },
  { id: "tree", Icon: TreePine },
];

const Visual = () => (
  <aside data-testid="auth-visual" className="relative flex h-56 flex-col justify-end overflow-hidden p-6 sm:h-64 lg:h-auto lg:min-h-screen lg:p-12">
    <img src="/images/login-fox.jpg" alt="Volpe in un prato fiorito" data-testid="auth-visual-image" className="absolute inset-0 h-full w-full object-cover object-[50%_35%]" />
    <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/85 via-emerald-900/20 to-transparent" />
    <div className="relative space-y-3 pb-6 text-white lg:pb-0">
      <div className="flex gap-2">
        {ECO_ICONS.map(({ id, Icon }) => (
          <span key={id} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-lime-200 ring-1 ring-white/25 backdrop-blur-sm">
            <Icon className="h-4 w-4" />
          </span>
        ))}
      </div>
      <p data-testid="auth-brand" className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-6xl">R.A.F. ECOLOGIA</p>
      <p className="max-w-md text-sm text-emerald-50/90 lg:text-base">Planner settimanale delle attività e dei turni</p>
    </div>
  </aside>
);

export const AuthCard = ({ title, subtitle, children, testId }) => (
  <div className="eco-shell min-h-screen lg:grid lg:grid-cols-[1.1fr_1fr]">
    <Visual />
    <main className="relative -mt-8 flex items-start justify-center overflow-hidden px-4 pb-10 lg:mt-0 lg:items-center lg:py-10">
      <Leaf className="pointer-events-none absolute -right-6 top-8 hidden h-48 w-48 rotate-12 text-emerald-200/50 lg:block" aria-hidden="true" />
      <Recycle className="pointer-events-none absolute -left-8 bottom-10 hidden h-40 w-40 -rotate-12 text-teal-200/50 lg:block" aria-hidden="true" />
      <div data-testid={testId} className="eco-card fade-up relative w-full max-w-sm space-y-5 p-6 sm:p-8">
        <img src="/images/logo-raf.png" alt="R.A.F. ECOLOGIA – servizi per l'ambiente" data-testid="auth-logo" className="mx-auto h-auto w-56 sm:w-64" />
        <div className="border-t border-emerald-100 pt-4">
          <h1 className="font-display text-xl font-bold tracking-tight text-emerald-950">{title}</h1>
          <p className="text-xs text-slate-500">{subtitle}</p>
        </div>
        {children}
      </div>
    </main>
  </div>
);
